import {StyledDetailsFieldsGrid} from '@/pages/project-details-scales-tests/style'
import {DetailsField} from '@/components/ui/details-atoms/DetailsAtoms'
import {Trash01Icon} from '@/components/ui/icon/Icon'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {formatLocaleDate} from '@/dayjs'
import {useTranslation} from '@/translations/i18n'
import {Button} from '@/components/ui/button/Button'
import {EvaluationScaleExtended, ScaleType} from '@/features/projects/types'
import {scaleTypeToLabel} from '../../utils'
import {StoreEditEvaluation} from '../store-evaluation/StoreEvaluation'
import {WarningLabel} from '@/components/ui/warning-label/WarningLabel'
import {Text} from '@/components/ui/text/Text'

type EvaluationRowProps =
    | {
          isPlaceholder: true
          evaluationScale?: undefined
          index?: undefined
          isEditMode?: undefined
          onDelete?: undefined
          onEdit?: undefined
          temporaryEvaluations?: undefined
          openingEventDate?: undefined
      }
    | {
          evaluationScale: EvaluationScaleExtended
          index: number
          isEditMode: boolean
          isPlaceholder?: false
          onDelete: () => void
          onEdit: (evaluationScale: EvaluationScaleExtended) => void
          temporaryEvaluations: EvaluationScaleExtended[]
          openingEventDate?: string
      }
export const EvaluationRow = ({
    evaluationScale,
    index,
    isEditMode,
    isPlaceholder,
    onDelete,
    onEdit,
    temporaryEvaluations,
    openingEventDate
}: EvaluationRowProps) => {
    const {t} = useTranslation()

    return (
        <StyledDetailsFieldsGrid>
            <DetailsField>
                <Text size="textSm" palette="neutral" shade="500">
                    {t('projects:evaluation_date')}
                </Text>
                <Text size="textSm" weight="500">
                    {isPlaceholder || !evaluationScale.evaluationDate ? (
                        <WarningLabel text={t('users:to_compile')} />
                    ) : (
                        formatLocaleDate(evaluationScale.evaluationDate, 'DD/MM/YYYY')
                    )}
                </Text>
            </DetailsField>
            <DetailsField>
                <Text size="textSm" palette="neutral" shade="500">
                    {t('projects:x_evaluation_scale', {count: isPlaceholder ? 1 : index + 1})}
                </Text>
                <Text size="textSm" weight="500">
                    {isPlaceholder ? (
                        <WarningLabel text={t('users:to_compile')} />
                    ) : (
                        t(scaleTypeToLabel[evaluationScale.type])
                    )}
                </Text>
            </DetailsField>
            <DetailsField>
                <Flexbox justify="space-between" align="flex-end" fullWidth>
                    <Flexbox direction="column" gap={1.5}>
                        <Text size="textSm" palette="neutral" shade="500">
                            {t('commons:total_score')}
                        </Text>
                        <Text size="textSm" weight="500">
                            {isPlaceholder ? <WarningLabel text={t('users:to_compile')} /> : evaluationScale.totalScore}
                        </Text>
                    </Flexbox>
                    {isEditMode && !isPlaceholder && (
                        <Flexbox>
                            {!(
                                (evaluationScale.type == ScaleType.enum.barthel_index ||
                                    evaluationScale.type == ScaleType.enum.lawton_iadl) &&
                                !evaluationScale.questions
                            ) && (
                                <StoreEditEvaluation
                                    temporaryEvaluations={temporaryEvaluations}
                                    onSubmit={onEdit}
                                    evaluationScale={evaluationScale}
                                    openingEventDate={openingEventDate}
                                />
                            )}
                            <Button variant="ghost" shape="square" size="sm" onClick={onDelete}>
                                <Trash01Icon />
                            </Button>
                        </Flexbox>
                    )}
                </Flexbox>
            </DetailsField>
        </StyledDetailsFieldsGrid>
    )
}
